<style lang="scss">
.demo__chatwoot--overlay {
  padding: 0 !important;
  width: 400px;
  height: 600px;
  background-color: rgb(249 249 251);
  border-radius: 16px;
  box-shadow: 0 5px 40px rgba(0, 0, 0, 0.16);
  opacity: 1 !important;

  will-change: transform, opacity;
  transform: translateY(0);
  overflow: hidden !important;
  position: fixed !important;

  z-index: 2147483000 !important;
  left: 20px !important;
  bottom: 105px !important;
  top: unset !important;

  .ant-popover-content {
    background-color: unset !important;
    height: 100%;
  }

  .ant-popover-inner,
  .ant-popover-inner > div,
  .ant-popover-inner-content,
  .demo__chatwoot--body {
    width: 100%;
    border-radius: unset !important;
    height: 100%;
    max-width: unset !important;
    background-color: unset !important;
  }
  .demo__chatwoot--body {
    padding-bottom: 0.75rem !important;
  }
  .demo__chatwoot-text-1 {
    color: rgb(17 17 19) !important;
    line-height: 2rem;
    font-size: 24px;
  }
  .demo__chatwoot-text-2 {
    color: #5a6169 !important;
    line-height: 1.5;
    font-size: 1.1rem;
    font-weight: 500;
  }
  .demo__chatwoot-text-3-yes,
  .demo__chatwoot--links a {
    color: rgb(214, 16, 110) !important;
    font-weight: 600 !important;
    cursor: pointer;
  }
  .demo__chatwoot-text-3-no {
    color: #5a6169 !important;
    font-weight: 600;
    cursor: not-allowed;
  }
  .ant-popover-arrow {
    display: none !important;
  }

  .this__chatwoot--image {
    height: 20.44px !important;
  }
  .demo__chatwoot--footer {
    justify-content: center;
  }
}
</style>
<template>
  <div
    class="support-button demo__pointer"
    @click="checkPopover"
    ref="triggerRef"
  >
    <span>
      {{ $t("Support") }}
    </span>
    <a-popover
      ref="popoverRef"
      :visible="isPopoverVisible"
      :title="false"
      :footer="false"
      overlayClassName="demo__chatwoot--overlay"
      trigger="click"
      :getPopupContainer="(triggerNode) => triggerNode.parentElement"
    >
      <template slot="content">
        <div
          class="demo__flex demo__flex-column demo__padding--20 demo__chatwoot--body"
          ref="popoverBody"
        >
          <div
            class="demo__weight--500 demo__margin-top--16 demo__margin-bottom--6 demo__chatwoot-text-1"
          >
            Здравствуйте!
          </div>

          <div class="demo__chatwoot-text-2">
            Чтобы продолжить необходимо принять соглашение
          </div>

          <div class="demo__margin-top--50 demo__chatwoot--links">
            <div class="demo__flex demo__flex-middle demo__pointer">
              <a-checkbox
                v-model="imAgree"
                class="demo__Checkbox--big demo__Checkbox--white demo__margin-right--9"
              >
              </a-checkbox>
              <div
                class="demo__font--11 demo__weight--500 demo__color--black demo__line-height--normal"
              >
                {{ $t("Auth access 1") }}
                <a :href="userLinks.personalData" target="_blank">{{
                  $t("Auth access 2")
                }}</a>
                {{ $t("Auth access 3") }}
                <a :href="userLinks.privacyPolicy" target="_blank">{{
                  $t("Auth access 4")
                }}</a>
                {{ $t("Auth access 5") }}
                <a :href="userLinks.userAgreement" target="_blank">{{
                  $t("Auth access 6")
                }}</a>
              </div>
            </div>
          </div>

          <div
            class="demo__flex demo__flex-middle demo__margin-top--20"
            v-bind:class="{
              'demo__chatwoot-text-3-yes': imAgree,
              'demo__chatwoot-text-3-no': !imAgree,
            }"
            @click="next"
          >
            <div class="demo__margin-right--7">Продолжить</div>
            <svg
              width="14"
              height="14"
              fill="none"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.267 4.209a.75.75 0 0 0-1.034 1.086l6.251 5.955H3.75a.75.75 0 0 0 0 1.5h14.734l-6.251 5.954a.75.75 0 0 0 1.034 1.087l7.42-7.067a.996.996 0 0 0 .3-.58.758.758 0 0 0-.001-.29.995.995 0 0 0-.3-.578l-7.419-7.067Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>

          <div
            class="demo__flex demo__flex-middle demo__flex-bottom demo__chatwoot--footer"
          >
            <img
              class="this__chatwoot--image"
              alt="Chatwoot"
              src="	https://helpdesk.3opinion.ai/brand-assets/logo_thumbnail.svg"
            />
            <div class="demo__margin-left--8 demo__chatwoot-text-2">
              Третье Мнение
            </div>
          </div>
        </div>
      </template>

      <span ref="popoverTrigger" style="display: none"></span>
    </a-popover>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    user: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isPopoverVisible: false,
      isSent: false,
      imAgree: localStorage.getItem("prmiagree"),
    };
  },
  computed: {
    ...mapGetters(["userLinks"]),
  },
  watch: {
    user() {
      this.setChatwootUser();
    },
  },
  beforeDestroy() {
    window.removeEventListener("chatwoot:ready", this.setChatwootUser);

    document.removeEventListener("click", this.handleOutsideClick);
  },
  created() {
    window.addEventListener("chatwoot:ready", this.setChatwootUser);
  },
  mounted() {
    this.setChatwootUser();
    document.addEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(e) {
      const popover = this.$refs.popoverRef;
      const trigger = this.$refs.triggerRef;
      const chatwootBody = this.$refs.popoverBody;
      if (
        this.isPopoverVisible &&
        !popover.$el.contains(e.target) &&
        !trigger.contains(e.target) &&
        !chatwootBody?.contains(e.target)
      ) {
        this.isPopoverVisible = false;
      }
    },
    checkPopover() {
      if (this.isPopoverVisible) {
        this.isPopoverVisible = false;
        return;
      }
      if (this.imAgree || this.user) {
        window?.$chatwoot.toggle();
        this.isPopoverVisible = false;
      } else if (!this.isPopoverVisible) {
        this.isPopoverVisible = true;
      }
    },
    next() {
      if (this.imAgree) {
        localStorage.setItem("prmiagree", true);
        window?.$chatwoot.toggle();
        this.isPopoverVisible = false;
      }
    },
    setChatwootUser() {
      if (!this.user || this.isSent) return;
      this.$nextTick(() => {
        if (window.$chatwoot) {
          const form = {
            email: this.user.email,
            identifier_hash: this.user.identifierHash,
            name: this.user.fullName || this.user.username,
            phone_number: this.user.phone,
          };
          window.$chatwoot.setUser(this.user.id + "", form);
          this.$debug(
            "CHATWOOT: setUser " + this.user.id + " -> ",
            "warning",
            JSON.stringify(form)
          );
          this.isSent = true;
        }
      });
    },
  },
};
</script>
